export enum RemoteDesktopStatus {
  Ready = 'READY',
  Unavailable = 'UNAVAILABLE',
}
